export default "<template>\n  <div>\n    <FdCalendar selectionMode=\"range\"></FdCalendar>\n  </div>\n</template>"